import React, {useRef, useState} from 'react'
import Nav from "react-bootstrap/Nav";
import {useDispatch, useSelector} from "react-redux";
import {Loading} from "../../../../../ui/loading/Loading";
import {Link} from "react-router-dom";
import {setRoute} from "../../../../../../store/routes";
import {setDatumIdOpen} from "../../../../../../store/user_organizations/teams/tools/connect_and_align";

export const CnATeamCard = ({data, setSelectedMember}:any) => {
    const dispatch = useDispatch();
    const team_obj = useSelector((state: any) => state.organization_team);
    const [displayTomis, setDisplayTomis] = useState(true)
    const [displayDeliverables, setDisplayDeliverables] = useState(false)
    const [displayActivities, setDisplayActivities] = useState(false)
    const [displayMessages, setDisplayMessages] = useState(false)

    let styleLink = {backgroundColor: '#fffade', color: 'black', padding: '5px 3px'};
    let styleLinkActive = {backgroundColor: '#fff5b4', color: 'black', borderColor: '#d7d191', padding: '5px 3px'};

    const resetSelectedTab = () => {
        setDisplayTomis(false);
        setDisplayDeliverables(false);
        setDisplayActivities(false);
        setDisplayMessages(false);
    }

    if(team_obj.isLoading === true) {
        return <Loading />;
    }

    const getAuthorKnowAs = (people_id: number) => {
        let author = team_obj?.data?.members?.find((member: { id: number; }) => (member.id === people_id))
        if(author === undefined) {
            return 'Not Found';
        }

        return author.KnownAs;
    }

    const getAuthorInitials = (people_id: number) => {
        let author = team_obj?.data?.members?.find((member: { id: number; }) => (member.id === people_id))
        if(author === undefined) {
            return '--';
        }

        return `${author.FirstName.substring(0, 1)}${author.LastName.substring(0, 1)}`;
    }

    const navigateToTool = (datum_id:number) => {
        const route = `/organizations/${team_obj.data.idOrganization}/teams/${team_obj.data.id}/CnA/${datum_id}`
        dispatch(setRoute(route))
        dispatch( setDatumIdOpen(datum_id) )
    }

    return (
        <div className="card bg-note">
            <div className="card-header">
                <div className="d-flex align-items-center">
                    <div className="rounded-circle" style={{backgroundColor: 'teal', padding: '3px', width: '30px', color: 'white', display: 'inline', textAlign: 'center', cursor: 'pointer'}}
                         onClick={() => setSelectedMember(data.user_id)}
                    >
                        {getAuthorInitials(data.user_id)}
                    </div>
                    <span className='mx-1' style={{cursor: 'pointer'}} onClick={() => setSelectedMember(data.user_id)}>{getAuthorKnowAs(data.user_id)}</span>
                </div>
            </div>
            <div className="card-body p-0">
                <Nav fill variant="tabs">
                    <Nav.Item onClick={() => {resetSelectedTab(); setDisplayTomis(true)}}>
                        <Nav.Link  style={displayTomis ? styleLinkActive : styleLink}>
                            ToMIs <sup style={{color: "red", fontWeight: 'bold'}}>{data.tomis.total_notifications > 0 && data.tomis.total_notifications}</sup>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item onClick={() => {resetSelectedTab(); setDisplayDeliverables(true)}}>
                        <Nav.Link style={displayDeliverables ? styleLinkActive : styleLink}>
                            Deliverables <sup style={{color: "red", fontWeight: 'bold'}}>{data.deliverables.total_notifications > 0 && data.deliverables.total_notifications}</sup>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item onClick={() => {resetSelectedTab(); setDisplayActivities(true)}}>
                        <Nav.Link style={displayActivities ? styleLinkActive : styleLink}>
                            Activities <sup style={{color: "red", fontWeight: 'bold'}}>{data.activities.total_notifications > 0 && data.activities.total_notifications}</sup>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item onClick={() => {resetSelectedTab(); setDisplayMessages(true)}}>
                        <Nav.Link style={displayMessages ? styleLinkActive : styleLink}>
                            Messages <sup style={{color: "red", fontWeight: 'bold'}}>{data.messages.total_notifications > 0 && data.messages.total_notifications}</sup>
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
                {
                    displayTomis &&
                    data.tomis.data.map( (datum:any) => (
                        <div
                            onClick={() => navigateToTool(datum.id)}
                            style={{borderBottom: 'solid 1px #939393FF', padding: '7px', paddingLeft: '10px', cursor: 'pointer'}} className="d-flex justify-content-between align-items-center">
                            <div>{datum.listOrder} - {datum.title}</div>
                            <div className='d-flex align-items-center'>
                                {
                                    datum.total_notifications > 0 &&
                                    <span className="badge" style={{backgroundColor: '#B22222', margin: '1px 3px'}}>{datum.total_notifications}</span>
                                }
                                {
                                    datum.datumNotificationReminderId !== null &&
                                    <span className="badge" style={{backgroundColor: 'teal', margin: '1px 3px'}}>
                                        <i className="fa fa-bell"></i>
                                    </span>
                                }
                            </div>
                        </div>
                    ))
                }
                {
                    displayDeliverables &&
                    data.deliverables.data.map( (datum:any) => (
                        <div onClick={() => navigateToTool(datum.id)}
                             style={{borderBottom: 'solid 1px #939393FF', padding: '7px', paddingLeft: '10px', cursor: 'pointer'}} className="d-flex justify-content-between align-items-center">
                            <div>{datum.listOrder} - {datum.title}</div>
                            <div className='d-flex align-items-center'>
                                {
                                    datum.total_notifications > 0 &&
                                    <span className="badge" style={{backgroundColor: '#B22222', margin: '1px 3px'}}>{datum.total_notifications}</span>
                                }
                                {
                                    datum.datumNotificationReminderId !== null &&
                                    <span className="badge" style={{backgroundColor: 'teal', margin: '1px 3px'}}>
                                        <i className="fa fa-bell"></i>
                                    </span>
                                }
                            </div>
                        </div>
                    ))
                }
                {
                    displayActivities &&
                    data.activities.data.map( (datum:any) => (
                        <div onClick={() => navigateToTool(datum.id)}
                            style={{borderBottom: 'solid 1px #939393FF', padding: '7px', paddingLeft: '10px', cursor: 'pointer'}} className="d-flex justify-content-between align-items-center">
                            <div>{datum.listOrder} - {datum.title}</div>
                            <div className='d-flex align-items-center'>
                                {
                                    datum.total_notifications > 0 &&
                                    <span className="badge" style={{backgroundColor: '#B22222', margin: '1px 3px'}}>{datum.total_notifications}</span>
                                }
                                {
                                    datum.datumNotificationReminderId !== null &&
                                    <span className="badge" style={{backgroundColor: 'teal', margin: '1px 3px'}}>
                                        <i className="fa fa-bell"></i>
                                    </span>
                                }
                            </div>
                        </div>
                    ))
                }
                {
                    displayMessages &&
                    data.messages.data.map( (datum:any) => (
                        <div onClick={() => navigateToTool(datum.id)}
                            style={{borderBottom: 'solid 1px #939393FF', padding: '7px', paddingLeft: '10px', cursor: 'pointer'}} className="d-flex justify-content-between align-items-center">
                            <div>{datum.listOrder} - {datum.title}</div>
                            <div className='d-flex align-items-center'>
                                {
                                    datum.total_notifications > 0 &&
                                    <span className="badge" style={{backgroundColor: '#B22222', margin: '1px 3px'}}>{datum.total_notifications}</span>
                                }
                                {
                                    datum.datumNotificationReminderId !== null &&
                                    <span className="badge" style={{backgroundColor: 'teal', margin: '1px 3px'}}>
                                        <i className="fa fa-bell"></i>
                                    </span>
                                }
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}
